/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as Error from './trans-website-productcustomernotification-error';

export const HeadLine = 'Website.ProductCustomerNotification.HeadLine';
export const Email = 'Website.ProductCustomerNotification.Email';
export const Success = 'Website.ProductCustomerNotification.Success';
export const SeveralSuccess = 'Website.ProductCustomerNotification.SeveralSuccess';
export const Fail = 'Website.ProductCustomerNotification.Fail';
